module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamond.0ca82af.webp";